import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as inquiriesService from "../../services/inquiry.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDateWithMonth, formateDateWithMonthAdmin, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder} from "rsuite";



const ViewInquiry = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("sidebar_link_inquiries"),
      url: "/admin/inquiries/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    inquiriesService
      .Details({ _id: params.id })
      .then((response) => {
        console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  VIEW INQUIRY
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault.name
                              ? capitalizeFirstLetter(showdefault.name)
                              : "N/A"}
                          </td>
                        </tr>     

                        <tr>
                          <th>{t("label_email")}</th>
                          <td style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault.email
                              ? showdefault.email
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_subject", "Subject")}</th>
                          <td style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault.subject
                              ? showdefault.subject
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_message")}</th>
                          <td style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault.message
                              ? capitalizeFirstLetter(showdefault.message)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Status")}</th>
                          <td>
                          {showdefault?.status === "solved" ? (
                                      <span className="badge badge-pill badge-success-light">
                                        {t("Solved")}
                                      </span>
                                    ) : showdefault?.status === "new" ? (
                                      <span className="badge badge-pill badge-warning-light">
                                        {t("New")}
                                      </span>
                                    ) : (
                                      <span className="badge badge-pill badge-danger-light">
                                        {t("Not solved")}
                                      </span>
                                    )}
                          </td>
                        </tr>


                        <tr>
                          <th>{t("label_inquiry_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDateWithMonthAdmin(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        {/* <tr>
                          <th>{t("label_modified_date")}</th>
                          <td>
                            {showdefault && showdefault.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr> */}
                      
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
               <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-5 back-button">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/inquiries/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewInquiry;
